import * as React from "react";
import Box from "@mui/material/Box";
import {
  Typography,
  AppBar,
  CssBaseline,
  Container,
  TextField,
  Avatar,
} from "@mui/material";
import {
  Authenticator,
  View,
  Image,
  useTheme,
  Text,
  components,
} from "@aws-amplify/ui-react";
import shivishImage from "./img/shivish.jpg";
import { useAuthenticator } from "@aws-amplify/ui-react";


export default function Display() {


  const { user, signOut } = useAuthenticator((context) => [context.user]);
  return (
    <div style={{ width: "100%" }}>
      <Typography variant="h8" component="div" sx={{ flexGrow: 1, m: 2 }}>
        Welcome,{" "}
        {user.username.charAt(0).toUpperCase() + user.username.slice(1)}.
      </Typography>
      {/* <Typography
        align="center"
        variant="h4"
        component="div"
        sx={{ flexGrow: 1, m: 2 }}
      >
        ShiVish Entertainment
      </Typography> */}
      <Image
        alt="ShiVish Entertainment"
        src={shivishImage} // Use the imported image
        style={{ width: "100%" }} // Optional: adjust width
      />

      <Typography
        align="center"
        variant="h5"
        component="div"
        sx={{ flexGrow: 1, m: 2 }}
      >
        Equipment Tracking Application.
      </Typography>

      <Typography variant="body1" component="div" sx={{ flexGrow: 1, m: 2 }}>
        This application is used to manage and maintain ShiVish Inventory. The
        application was designed and developed as a capstone project by
        TechTitans Team during the IT492 and IT493 courses at{" "}
        <b>George Mason University</b>. <p>Registered users will be able to
        check-in and check-out eqiupment, and also report any damaged
        equipment via the application.</p>


        Application instructions can be found{" "}
        <a
          href="https://applicationinstructionsit493.s3.us-east-1.amazonaws.com/Training+Dcument.pdf"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>
        <br />
        <br />
        TechTitans Team:
        <ul>
          <li>Mario Ayala</li>
          <li>Twinkle Ray</li>
          <li>Ian Coulter</li>
          <li>Faisal Sultani</li>
          <li>Mustafa Kohistani</li>
          <li>Shokri Sandi</li>
        </ul>
      </Typography>
    </div>
  );
}
